import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { navLinks, companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled ? 'bg-white/98 backdrop-blur-md shadow-sm' : 'bg-transparent'
    }`}>
      {/* Top bar */}
      <div className={`transition-all duration-500 ${
        isScrolled ? 'h-0 opacity-0 overflow-hidden' : 'h-auto opacity-100 bg-[#252A32] text-white py-2.5'
      }`}>
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-8">
            <a href={`tel:${companyInfo.phones[0]}`} className="flex items-center gap-2 hover:text-[#B8956B] transition-colors">
              <Phone className="w-3.5 h-3.5" />
              <span className="font-medium tracking-wide">{companyInfo.phones[0]}</span>
            </a>
            <a href={`mailto:${companyInfo.email}`} className="hidden sm:flex items-center gap-2 hover:text-[#B8956B] transition-colors">
              <Mail className="w-3.5 h-3.5" />
              <span className="font-medium tracking-wide">{companyInfo.email}</span>
            </a>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-[#B8956B] font-medium tracking-wider text-xs uppercase">30+ Years of Excellence</span>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="container mx-auto px-4 py-5">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" onClick={() => scrollToSection('home')} className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-md bg-[#252A32] flex items-center justify-center">
              <span className="text-[#B8956B] font-bold text-lg heading-display">B</span>
            </div>
            <div>
              <h1 className={`font-semibold text-xl tracking-tight transition-colors ${
                isScrolled ? 'text-[#252A32]' : 'text-white'
              }`}>
                Becone
              </h1>
              <p className={`text-[10px] uppercase tracking-[0.2em] transition-colors ${
                isScrolled ? 'text-[#404752]' : 'text-gray-400'
              }`}>Elevators</p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`nav-link text-sm font-medium tracking-wide transition-colors ${
                  isScrolled ? 'text-[#404752] hover:text-[#252A32]' : 'text-gray-300 hover:text-white'
                }`}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <Button 
              onClick={() => scrollToSection('contact')}
              className="btn-gold text-white font-medium px-7 py-2.5 border-0 tracking-wide"
            >
              Get Free Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className={`w-6 h-6 ${isScrolled ? 'text-[#252A32]' : 'text-white'}`} />
            ) : (
              <Menu className={`w-6 h-6 ${isScrolled ? 'text-[#252A32]' : 'text-white'}`} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 bg-white rounded-xl shadow-xl border border-gray-100">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left px-6 py-3.5 text-[#404752] hover:bg-[#FDFBF7] hover:text-[#252A32] transition-colors font-medium"
              >
                {link.label}
              </button>
            ))}
            <div className="px-6 pt-4">
              <Button 
                onClick={() => scrollToSection('contact')}
                className="w-full btn-gold text-white font-medium border-0"
              >
                Get Free Quote
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
